import request from '@/utils/request'


export function keepSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/keep/keepSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function keepBatchDelete(data) {
    return request({
        url: `api/serviceCenter/keep/keepBatchDelete`,
        method: 'post',
        data,
    })
}

export function batchDelete(data) {
    return request({
        url: `api/serviceCenter/keep/batchDelete`,
        method: 'post',
        data,
    })
}


export function orderProduction(data) {
    return request({
        url: `api/serviceCenter/keep/orderProduction`,
        method: 'post',
        data,
    })
}
export function keepRemake(data) {
    return request({
        url: `api/serviceCenter/keep/keepRemake`,
        method: 'post',
        data,
    })
}

export function selectProductCategory(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/selectProductCategory`,
        method: 'post',
        data,
    })
}


export function addToProduct(data) {
    return request({
        url: `api/serviceCenter/keep/addToProduct`,
        method: 'post',
        data,
    })
}

export function addProduct(data) {
    return request({
        url: `api/serviceCenter/product/addProduct`,
        method: 'post',
        data,
    })
}

export function productSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/productSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function productSelectInfoWeb(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/product/productSelectInfoWeb?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function selectProduct(data) {
    return request({
        url: `api/serviceCenter/product/selectProduct?productId=${data}`,
        method: 'post',
    })
}
